module.exports = __webpack_public_path__ + "static/media/compliance--en.082e7b23.png";